export default {
  passwordChangeTitle: 'Manage password',
  currentPasswordPlaceholder: 'Current Password',
  inputPasswordNewPlaceholder: 'New Password',
  inputPasswordNewConfirmPlaceholder: 'Confirm new password',
  passwordChangeButtonUpdate: 'Update',
  passwordChangeButtonSending: 'Sending..',
  passwordChangeSuccessMessage: 'Password updated successfully',
  passwordChangeInvalidMessage: 'An error has occurred while verifying your data',
  passwordChangeInvalidVoidMessage: 'Incomplete fields',
  passwordChangeNotEqualMessage: 'Passwords do not match',
  passwordChangeLengthMinMessage: 'Password must be 6 characters',
  goBackToPreviousVersion: 'Previous version',
  chats: 'Smart Chat',
  persons: 'People',
  metrics: 'Dashboard',
  metricsSuperAdmin: 'Dashboard (Super Admin)',
  logout: 'Logout',
  forms: 'Forms',
  auth: 'Authenticator',
  imports: 'Imports',
  opportunities: 'Sales',
  massiveSend: 'Campaigns',
  microsites: 'My Keybe',
  autobots: 'Autobots',
  sound: 'Sound',
  pushNotifications: 'Push Notifications',
  liteVersionTitle: 'You are in a Lite version',
  liteVersionMessage: 'To have a better experience, we invite you to download our app',
  downloadApk: 'Or download the APK here',
  errorGettingConfig: 'Error getting configuration',
  errorSavingConfig: 'Error saving configuration',
  configSaved: 'Configuration saved',
  badSchedule: 'Invalid schedule',
  extensions: 'Extensions',
  insecurePassword: 'Insecure password',
  // youHaveAWeakPassword: 'Tu contraseña no es muy segura 😥',
  // updateYourPasswordNow: 'Actualiza tu contraseña ahora'
  youHaveAWeakPassword: 'Your password is insecure 😥',
  updateYourPasswordNow: 'Update your password now',
  termsDialogMessage1: 'We updated our',
  termsDialogMessage2: 'If you agree, click \'I accept\' 👰‍♀️ and let\'s keep growing together!',
  termsDialogMessage3: 'I accept the new',
  termsDialogMessage4: 'and the',
  termsAndConditions1: 'Terms and conditions',
  serviceAgreement: 'Service agreement',
  termsDialogMessage5: 'Has anything changed?🤔',
  termsDialogMessage6: 'Update your data and keep inform about everything we have for you.',
  goToV6: 'Go to V6'
}
